<script>
import RecoverPasswordForm from '@/components/recoverPassword/RecoverPasswordForm.vue';

export default {
  data() {
    return {
      imgYautyPath: "../public/assets/login/login_logo.png",
      imgLogginPath: '../public/assets/login/login.png',
    };
  },
  components: {
    RecoverPasswordForm,
  },
};
</script>

<template>
    <RecoverPasswordForm />
</template>

<style lang="scss" scoped>
.recover-password__container{
  background-color: white;
}
</style>
